import { TranslatedString } from 'lemunzo-api';

export class OptionModel {
    label: TranslatedString;

    constructor(label: TranslatedString) {
        this.label = label;
    }
}
